import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectors = [{
  title: "Professional Driveway sealing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/driveway_sealing.png",
  tag: "Construction",
  description: "Professional driveway sealing services.",
  link: "/ServicesPage"
}, {
  title: "Corporate Offices",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/office_cleaning_modern.png",
  tag: "Corporate",
  description: "Immaculate workspaces for productivity.",
  link: "/ServicesPage"
}, {
  title: "Strata Buildings",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/strata_building_exterior.png",
  tag: "Residential",
  description: "Pristine common areas and foyers.",
  link: "/ServicesPage"
}, {
  title: "Gyms & Fitness",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/gym_fitness_center.png",
  tag: "Health",
  description: "Hygienic environments for members.",
  link: "/ServicesPage"
}, {
  title: "Childcare Centres",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/childcare_daycare_interior.png",
  tag: "Education",
  description: "Safe, germ-free spaces for children.",
  link: "/ServicesPage"
}, {
  title: "Commercial Property",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/commercial_property_foyer.png",
  tag: "Commercial",
  description: "High-end maintenance for assets.",
  link: "/ServicesPage"
}, {
  title: "Retail Spaces",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/retail_store_interior.png",
  tag: "Retail",
  description: "Inviting shopping environments.",
  link: "/ServicesPage"
}];
export default function SectorsWeTransform() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="sectors-we-transform" ref={ref} className={`dark bg-background text-foreground py-20 relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 mb-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-white">
              Sectors We <span className="text-primary">Transform</span>
            </h2>
            <p className="text-muted-foreground text-lg">
              Delivering the gold standard of cleanliness across diverse industries. 
              We tailor our premium services to meet the unique demands of your environment.
            </p>
          </div>
          <div className="hidden md:block">
            <Button asChild variant="outline" className="border-primary/20 hover:border-primary text-primary hover:text-primary hover:bg-primary/10">
              <Link to="/ServicesPage">
                View All Industries <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full">
        <ScrollArea className="w-full whitespace-nowrap pb-8">
          <div className="flex w-max space-x-6 px-4 md:px-8 lg:px-16">
            {sectors.map((sector, i) => <Link key={i} to={sector.link} className="group relative block h-[450px] w-[300px] md:w-[350px] shrink-0 overflow-hidden rounded-xl border border-border/50 bg-card shadow-lg transition-all hover:shadow-primary/20 hover:border-primary/50" data-index={i}>
                {}
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-110" style={{
              backgroundImage: `url(${sector.image})`
            }} />

                {}
                <div className="absolute inset-0 bg-black/80 transition-colors duration-500 group-hover:bg-black/40" />

                {}
                <Badge className="absolute top-4 right-4 z-20 bg-primary text-primary-foreground hover:bg-primary border-none shadow-md px-3 py-1 text-xs uppercase tracking-wider font-bold">
                  {sector.tag}
                </Badge>

                {}
                <div className="absolute inset-0 z-10 flex flex-col items-center justify-center p-6 text-center transition-all duration-500">
                  <div className="mt-auto mb-auto group-hover:translate-y-4 transition-transform duration-500">
                    <h3 className="text-2xl font-bold text-white mb-2 drop-shadow-md">
                      {sector.title}
                    </h3>
                    <div className="h-1 w-12 bg-primary mx-auto rounded-full mb-4 transition-all duration-500 group-hover:w-24" />
                  </div>
                  
                  <div className="opacity-0 translate-y-8 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 mb-12">
                    <p className="text-white/90 font-medium text-sm md:text-base max-w-[250px] mx-auto leading-relaxed drop-shadow-sm">
                      {sector.description}
                    </p>
                  </div>
                </div>
              </Link>)}
          </div>
          <ScrollBar orientation="horizontal" className="bg-secondary/50" />
        </ScrollArea>
      </div>

      <div className="container mx-auto px-4 mt-8 md:hidden">
        <Button asChild className="w-full" variant="outline">
          <Link to="/ServicesPage">
            View All Industries <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </section>;
}